<aa-timeline-group *ngFor="let tlGroup of tlGroups" [tlGroup]="tlGroup"></aa-timeline-group>
